<template>
  <div class="course-cont">
    <div class="chapters-section">
      <div v-for="(chapter, chapIndex) in chapters" :key="chapIndex" class="chapter-card">
        <h3 class="chapter-title">{{ chapter.title }}</h3>
        <ul class="section-list">
          <li
            v-for="(item, index) in chapter.children"
            :key="index"
            class="section-item"
          >
            <!-- 章节内容主行 -->
            <div class="section-main">
              <div class="section-info">
                <span class="section-number">{{ item.chapterNumbering }}</span>
                <span class="section-title">{{ item.title }}</span>
              </div>

              <!-- 视频标识 -->
              <span
                v-if="item.videoSrc"
                class="video-marker"
                @click="showVideoPlayer(item)"
              >
                <i class="icon-play"></i>
                <span class="video-text">视频</span>
              </span>
            </div>

            <!-- 子章节列表（独立块级元素） -->
            <ul
              v-if="item.children && item.children.length > 0"
              class="sub-section-list"
            >
              <li
                v-for="(subItem, subIndex) in item.children"
                :key="subIndex"
                class="section-item"
              >
                <div class="section-main">
                  <div class="section-info">
                    <span class="section-number">{{ subItem.chapterNumbering }}</span>
                    <span class="section-title">{{ subItem.title }}</span>
                  </div>
                  <span
                    v-if="subItem.videoSrc"
                    class="video-marker"
                    @click="showVideoPlayer(subItem)"
                  >
                    <i class="icon-play"></i>
                    <span class="video-text">视频</span>
                  </span>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <!-- 视频播放弹窗 -->
    <!-- 资源预览弹出层 -->
    <div v-if="showVideo" class="modal-mask" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-header">
          <span class="modal-title">{{ currentVideoTitle }}</span>
          <div class="modal-actions">
            <button
              class="fullscreen-btn"
              @click="toggleFullscreen"
              aria-label="全屏"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4H16V6H8V4ZM8 18H16V20H8V18ZM4 8V16H6V8H4ZM18 8V16H20V8H18Z" fill="currentColor"/>
              </svg>
            </button>
            <button
              class="close-btn"
              @click.stop="closeModal"
              aria-label="关闭"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
          </div>
        </div>
        <div class="modal-content">
          <!-- 加载提示 -->
          <div v-if="modalLoading" class="modal-loading">
            <div class="spinner large"></div>
            <span>内容加载中...</span>
          </div>
          <!-- 实际内容 -->
          <iframe
            ref="modalIframe"
            :src="currentVideoSrc"
            frameborder="0"
            style="width: 100%; height: 100%"
            class="iframe-content"
            @load="handleModalLoad"
          ></iframe>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    data() {
      return {
        chapters: [],  // 存储从后台获取的章节数据
        showVideo: false,
        currentVideoSrc: '',
        modalLoading: false,
        modalType: "web",
        currentVideoTitle: ''
      }
    },
    props: {
      lessonsId: {  // 接收课程ID（对应数据库lessons_id字段）
        type: Number,
        required: true
      }
    },
    mounted() {
      this.fetchChaptersByLessonsId();  // 组件加载后立即请求数据
    },
    methods: {
      // 模态框内容加载完成
      handleModalLoad() {
        this.modalLoading = false; // iframe加载完成后隐藏提示
      },
      closeModal() {
        this.showVideo = false;
        this.currentVideoSrc = '';
        this.modalLoading = false; // 关闭时重置状态
      },
      // 全屏功能（保持原有逻辑）
      toggleFullscreen() {
        this.$nextTick(() => {
          const el = this.modalType === 'web' ? this.$refs.modalIframe : this.$refs.modalVideo;
          if (el.requestFullscreen) {
            el.requestFullscreen();
          } else {
            alert('当前浏览器不支持全屏功能');
          }
        });
      },
      // 根据lessons_id获取章节数据（严格对应SQL表字段）
      async fetchChaptersByLessonsId() {
        try {
          const res = await axios.get('/api/lessons-chapters/list', {
            params: {
              //lessonsId: this.lessonsId  // 请求参数使用lessons_id（与数据库字段一致）
              lessonsId: 1
            }
          });

          // 转换后台数据（根据SQL表字段映射）
          this.chapters = res.data.map(chapter => ({
            ...chapter,
            // 保留完整子节点结构
            children: chapter.children || []
          }));
        } catch (error) {
          console.error('获取章节数据失败:', error);
          // 可添加错误提示（如this.$message.error）
        }
      },

      showVideoPlayer(item) {
        this.modalLoading = true;
        this.currentVideoTitle = item.title;
        this.currentVideoSrc = "https://oss.keming365.com/"+item.videoSrc;  // 视频地址来自数据库video_src字段
        this.showVideo = true;
      }
    }
  }
</script>

<style scoped>
  /* 章节卡片样式 */
  .chapter-card {
    margin-bottom: 24px;
    padding: 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }

  .chapter-title {
    margin: 0 0 12px 0;
    color: #2c3e50;
    font-size: 1.2em;
  }

  /* 章节列表项 */
  .section-item {
    margin: 4px 0;
    width: 100%;
  }

  .section-main {
    display: flex;
    justify-content: space-between; /* 关键：左右两端对齐 */
    align-items: center;
    padding: 8px 12px;
    border-bottom: 1px solid #f0f2f5;
    border-radius: 4px;
    transition: all 0.2s ease;
    width: 100%; /* 强制占满宽度 */
  }

  .section-main:hover {
    background-color: #f8f4ff;
    box-shadow: 0 1px 4px rgba(106, 13, 173, 0.15);
    transform: translateX(2px);
  }

  .section-info {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1; /* 占满剩余空间 */
  }

  /* 视频标识（关键：固定右侧位置） */
  .video-marker {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #6a0dad;
    font-size: 0.9em;
    cursor: pointer;
    min-width: 60px; /* 固定最小宽度 */
    flex-shrink: 0; /* 禁止收缩 */
  }

  .video-marker:hover .icon-play {
    filter: brightness(0.8);
  }

  .video-marker:hover .video-text {
    font-weight: 500;
  }

  /* 多级缩进样式（统一使用section-list类） */
  .section-list {
    padding-left: 24px; /* 一级缩进 */
    margin: 8px 0;
  }

  .section-list .section-list {
    padding-left: 20px; /* 二级缩进（比一级少4px，形成层级感） */
  }

  /* 子章节主内容区（与父级保持一致样式） */
  .section-list .section-main {
    padding-left: 8px; /* 微调内边距保持视觉平衡 */
    background-color: #ffffff;
  }

  .section-list .section-main:hover {
    background-color: #fdf9ff;
    box-shadow: 0 1px 3px rgba(106, 13, 173, 0.1);
    transform: translateX(1px);
  }

  /* 基础元素样式 */
  .section-number {
    color: #6a0dad;
    font-weight: 500;
    min-width: 40px;
  }

  .section-title {
    flex: 1;
    color: #34495e;
    font-size: 0.95em;
  }

  .instructor {
    color: #7f8c8d;
    font-size: 0.9em;
  }

  .icon-user {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 4px;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%237f8c8d"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>') no-repeat center;
  }

  .icon-play {
    width: 18px;
    height: 18px;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%236a0dad"><path d="M8 5v14l11-7z"/></svg>') no-repeat center;
  }

  .video-text {
    line-height: 1;
  }

  /* 模态框样式 */
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  /* 模态框z-index提升（确保始终在最上层） */
  .modal-mask {
    z-index: 1001; /* 原1000，提升1层 */
  }

  .modal-container {
    width: 90%;
    max-width: 1024px;
    background: white;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
  }

  .modal-container {
    width: 95%;
    border-radius: 12px;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    background: #1e293b;
    color: white;
  }

  .modal-title {
    font-size: 1.25rem;
    font-weight: 500;
    margin: 0;
  }

  .modal-actions {
    display: flex;
    gap: 12px;
  }

  .modal-actions button {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 4px;
    transition: color 0.2s ease;
  }

  .modal-actions button:hover {
    color: #ff4757; /* 红色强调 */
  }

  .modal-content {
    height: 60vh;
    min-height: 400px;
    padding: 24px;
    background: #f8f9fa;
  }

  /* 响应式调整 */
  @media (max-width: 768px) {
    .card {
      width: 100%;
      max-width: 360px;
      margin: 8px auto;
    }

    .image-wrapper {
      height: 160px;
    }

    .modal-container {
      width: 95%;
      border-radius: 12px;
    }

    .modal-content {
      height: 50vh;
      padding: 16px;
    }
  }

  /* 模态框加载提示 */
  .modal-content {
    height: 60vh;
    min-height: 400px;
    padding: 24px;
    background: #f8f9fa;
    position: relative;
  }

  .modal-loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 12px;
    color: #64748b;
    font-size: 16px;
  }

  /* 加载动画 */
  .spinner {
    width: 16px;
    height: 16px;
    border: 2px solid #e5e7eb;
    border-top-color: #3b82f6;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  .spinner.large {
    width: 24px;
    height: 24px;
    border-width: 3px;
  }

  .iframe-content {
    border-radius: 12px;
    background: white;
  }
</style>




// WEBPACK FOOTER //
// src/components/tp/VideosPage.vue